import { Component, HostListener, OnInit } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { PageLayout } from '@cvx/nextpage';
import { GraphUserService } from 'src/app/services/graph/GraphUser.service';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styles: [
        '.main.container section { width: 100%; }',
        '.more-style { border-bottom: 1px solid #fff; }'
    ]
})

export class HomeComponent implements OnInit {
    showCAIAlert: boolean = true;
    showDashboardLink: boolean = false;

    PageLayout = PageLayout;
    constructor(private authService: CalAngularService, private graphUserService: GraphUserService) {
    }
    ngOnInit(): void {
        this.showDashboardLink = this.graphUserService.CheckIsRequestReadAll(this.authService.cvxClaimsPrincipal);
        const expiry = localStorage.getItem('caiBannerClosed_expiry');
        const now = new Date().getTime();
        
        if (!expiry || now > +expiry) {
            this.showCAIAlert = true;
        } else {
            this.showCAIAlert = false;
        }
    }
    @HostListener('click', ['$event'])
    closeAlert(event: MouseEvent) {
      const target = event.target as HTMLElement;
    
      if (target.id === 'alert-shim-close') {
        this.showCAIAlert = false;
    
        // Hide alert for 2 weeks (1209600000 ms)
        const expiryTime = new Date().getTime() + 1209600000; 
        localStorage.setItem('caiBannerClosed_expiry', expiryTime.toString());
    
        event.preventDefault();
      }
    }
}